import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { StepButton } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Dialog from '../../../../../components/Dialog/Dialog';
import { RootState } from '../../../../../reduxService';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { putMacro1ProjectAsync, putMacro2ProjectAsync } from '../../../../api/store/BeMaccaferriStoreHelper';
import { commitProject as m1Commit, projectToData as m1PtD, setHasBeenRan as setHBRM1 } from '../../../../Macro1/store/project/projectslice';
import { setOutputData as m1SOD, updateValidation as m1UV } from '../../../../Macro1/store/project/resultsSlice';
import { commitProject as m2Commit, projectToData as m2PtD, setHasBeenRan as setHBRM2 } from '../../../../Macro2/store/project/projectslice';
import { setOutputData as m2SOD, updateValidation as m2UV } from '../../../../Macro2/store/project/resultsSlice';
import { endpoint } from '../../../../pages';
import { setHasBeenSent } from '../../../../store/projectInfo/projectInfoSlice';
import './Stepper.scss';

/* const steps = [t('breadcrumb_project_info'), t('breadcrumb_project_type'),  t('breadcrumb_design_condition')]; */

export default function HorizontalLinearStepper() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set<number>());
    const [loading, setLoading] = React.useState<boolean>(false);

    const location = useLocation();
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();

    const [projectType, setProjectType] = React.useState<string>('');
    const [ErrorDialog, setErrorDialog] = React.useState<string>('');
    const closeErrorDialog = () => {
        setErrorDialog('');
    };

    const currentProjectBase = useSelector((state: RootState) => {
        return { ...state.projectInfo.data };
    });

    const currentProjectM1 = useSelector((state: RootState) => {
        if (window.location.href.includes('Macro1')) {
            if (projectType !== 'macro1') setProjectType('macro1');
            return { ...state.Macro1.project.data };
        }
        return undefined;
    });

    const currentProjectM2 = useSelector((state: RootState) => {
        if (window.location.href.includes('Macro2')) {
            if (projectType !== 'macro2') setProjectType('macro2');
            return { ...state.Macro2.project.data };
        }
        return undefined;
    });

    const startFormValidation = async () => {
        setLoading(true);
        if (currentProjectM1) {
            dispatch(
                m1UV({
                    startValidation: true,
                    anchorBar: false,
                    mesh: false,
                    rockSlope: false,
                    safetyCoefficients: false,
                    siteEnvironmentalLevel: false,
                }),
            );
        } else if (currentProjectM2) {
            dispatch(
                m2UV({
                    startValidation: true,
                    crest: false,
                    mesh: false,
                    rockSlope: false,
                    safetyCoefficients: false,
                    siteEnvironmentalLevel: false,
                }),
            );
        }
    };

    const { id } = useParams();

    const sendProjectData = async () => {
        //TODO: verify how mapImage is being handled
        if (currentProjectM1) {
            try {
                currentProjectM1.projectId = id;
                dispatch(setHBRM1(true));
                const results = await putMacro1ProjectAsync(m1PtD(currentProjectM1));
                dispatch(m1Commit(currentProjectM1));
                dispatch(m1SOD(results.data));
                navigate(`/results/${currentProjectBase.projectType}/${currentProjectBase.projectId}`);
            } catch (ex) {
                setErrorDialog(((ex as any)?.response?.data?.PropertiesNotValid ?? '' + t('errors.projectCommit.unspecific_error')).replaceAll(', ', '\n'));
            }
        } else if (currentProjectM2) {
            try {
                dispatch(setHBRM2(true));
                const results = await putMacro2ProjectAsync(m2PtD(currentProjectM2));
                dispatch(m2Commit(currentProjectM2));
                dispatch(m2SOD(results.data));
                navigate(`/results/${currentProjectBase.projectType}/${currentProjectBase.projectId}`);
            } catch (ex) {
                setErrorDialog(((ex as any)?.response?.data?.PropertiesNotValid ?? '' + t('errors.projectCommit.unspecific_error')).replaceAll(', ', '\n'));
            }
        }
        dispatch(setHasBeenSent(true));
        setLoading(false);
    };

    const currentResultsM1 = useSelector((state: RootState) => {
        return { ...state.Macro1.results.data };
    });

    const currentResultsM2 = useSelector((state: RootState) => {
        return { ...state.Macro2.results.data };
    });

    useEffect(() => {
        if (!currentResultsM1.validation?.startValidation) return;
        //console.log("validationUpdate", currentResultsM1.validation);
        if (currentResultsM1.validation?.anchorBar && currentResultsM1.validation?.mesh && currentResultsM1.validation?.rockSlope && currentResultsM1.validation?.safetyCoefficients) {
            if (currentResultsM1.validation?.anchorBarErrors) {
                setErrorDialog('' + t('errors.projectCommit.anchorBar_error'));
                setLoading(false);
            } else if (currentResultsM1.validation?.meshErrors) {
                setErrorDialog('' + t('errors.projectCommit.mesh_error'));
                setLoading(false);
            } else if (currentResultsM1.validation?.rockSlopeErrors) {
                setErrorDialog('' + t('errors.projectCommit.rockSlope_error'));
                setLoading(false);
            } else if (currentResultsM1.validation?.safetyCoefficientsErrors) {
                setErrorDialog('' + t('errors.projectCommit.securityCoefficients_error'));
                setLoading(false);
            } else {
                sendProjectData();
            }
            dispatch(
                m1UV({
                    startValidation: false,
                    anchorBar: false,
                    mesh: false,
                    rockSlope: false,
                    safetyCoefficients: false,
                    siteEnvironmentalLevel: false,
                    anchorBarErrors: false,
                    meshErrors: false,
                    rockSlopeErrors: false,
                    safetyCoefficientsErrors: false,
                    siteEnvironmentalLevelErrors: false,
                }),
            );
        }
    }, [JSON.stringify(currentResultsM1.validation)]);

    useEffect(() => {
        if (!currentResultsM2.validation?.startValidation) return;
        //console.log("validationUpdate", currentResultsM2.validation);
        if (currentResultsM2.validation?.crest && currentResultsM2.validation?.mesh && currentResultsM2.validation?.rockSlope && currentResultsM2.validation?.safetyCoefficients) {
            if (currentResultsM2.validation?.crestErrors) {
                setErrorDialog('' + t('errors.projectCommit.crest_error'));
                setLoading(false);
            } else if (currentResultsM2.validation?.meshErrors) {
                setErrorDialog('' + t('errors.projectCommit.mesh_error'));
                setLoading(false);
            } else if (currentResultsM2.validation?.rockSlopeErrors) {
                setErrorDialog('' + t('errors.projectCommit.rockSlope_error'));
                setLoading(false);
            } else if (currentResultsM2.validation?.safetyCoefficientsErrors) {
                setErrorDialog('' + t('errors.projectCommit.securityCoefficients_error'));
                setLoading(false);
            } else {
                sendProjectData();
            }
            dispatch(
                m2UV({
                    startValidation: false,
                    crest: false,
                    mesh: false,
                    rockSlope: false,
                    safetyCoefficients: false,
                    siteEnvironmentalLevel: false,
                    crestErrors: false,
                    meshErrors: false,
                    rockSlopeErrors: false,
                    safetyCoefficientsErrors: false,
                    siteEnvironmentalLevelErrors: false,
                }),
            );
        }
    }, [JSON.stringify(currentResultsM2.validation)]);

    const handleStep = (step: any) => {
        if (!step.resultsCondition) {
            if (step.endpoint == endpoint.designCondition) {
                if ((!!currentProjectM1 && currentProjectM1.readOnly) || (!!currentProjectM2 && currentProjectM2.readOnly)) {
                    window.location.href = `/designCondition/${currentProjectBase.projectType}/${currentProjectBase.projectId}`;
                } else {
                    navigate(`/designCondition/${currentProjectBase.projectType}/${currentProjectBase.projectId}`);
                }
            } else if (!!currentProjectM1 || !!currentProjectM2) {
                navigate(step.endpoint + `?id=${currentProjectBase.projectId}&macro=${!!currentProjectM1 ? 1 : 2}`);
            } else {
                navigate(step.endpoint);
            }
        } else {
            if (currentProjectBase.hasBeenSent) {
                navigate(`/results/${currentProjectBase.projectType}/${currentProjectBase.projectId}`);
            } else {
                startFormValidation();
            }
        }
    };

    const steps = [
        {
            label: t('breadcrumb_project_info'),
            endpoint: endpoint.projectInfo,
            completed: false,
            skipped: false,
        },
        {
            label: t('breadcrumb_project_type'),
            endpoint: endpoint.projectType,
            completed: false,
            skipped: false,
        },
        {
            label: t('breadcrumb_design_condition'),
            endpoint: endpoint.designCondition,
            completed: false,
            skipped: false,
        },
        {
            label: currentProjectBase.hasBeenSent ? t('breadcrumb_results') : t('breadcrumb_results_run'),
            endpoint: endpoint.results,
            completed: false,
            skipped: false,
            resultsCondition: true,
        },
        //breadcrumb_results_run
    ];

    React.useEffect(() => {
        if (location.pathname.includes(endpoint.projectInfo)) setActiveStep(0);
        if (location.pathname.includes(endpoint.projectType)) setActiveStep(1);
        if (location.pathname.includes('designCondition')) setActiveStep(2);
        if (location.pathname.includes('results')) setActiveStep(3);
    }, [location]);

    const isStepSkipped = (step: number) => {
        return skipped.has(step);
    };

    const handleNext = () => {
        let newSkipped = skipped;
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <>
            <Box sx={{ width: '100%', padding: '20px 32px 20px 32px' }}>
                <Stepper nonLinear className='stepper' activeStep={activeStep}>
                    {steps.map((step, index) => {
                        if (isStepSkipped(index)) {
                            step.skipped = true;
                        }
                        return (
                            <Step
                                completed={(step.resultsCondition && currentProjectBase.hasBeenSent) || (activeStep > index && !step.skipped)}
                                key={step.label}
                                disabled={(step.resultsCondition ? activeStep < 2 || currentProjectM1?.disableRun || currentProjectM2?.disableRun : activeStep < index) || activeStep == index}>
                                <StepButton
                                    icon={step.resultsCondition && !currentProjectBase.hasBeenSent ? <PlayArrowIcon /> : undefined}
                                    className={`step-button ${step.resultsCondition && !currentProjectBase.hasBeenSent ? 'step-button-run' : ''}`}
                                    color={'inherit'}
                                    onClick={() => handleStep(step)}>
                                    {step.label}
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
            </Box>
            <Modal open={loading || ((currentResultsM1.validation?.startValidation || currentResultsM2.validation?.startValidation) ?? false)}>
                <CircularProgress size={80} className='loader' />
            </Modal>
            <Dialog open={!!ErrorDialog && ErrorDialog.length > 0} title={`${t('errors.projectCommit.title')}`} onClose={closeErrorDialog}>
                <>
                    <div className='error-dialog-intro'>{`${t('errors.projectCommit.message')}`}</div>
                    <br />
                    <div className='error-dialog-list'>{ErrorDialog}</div>
                </>
            </Dialog>
        </>
    );
}
